import "styles/pages/single-post.scss";

import React from "react";
import { graphql } from "gatsby";

import Seo from "components/Seo";
import Layout from "components/Layout";
import Breadcrumps from "components/Breadcrumps";
import SubpageHeader from "components/SubpageHeader";
import PostInfo from "../page_components/blog/single/PostInfo";
import PostContent from "../page_components/blog/single/Content";
import PostShare from "../page_components/blog/single/PostShare";

const SinglePost = ({ data: { wpPost } }) => {
  const breadcrumps_data = [
    {
      name: "Blog",
      href: "/blog/",
    },
    {
      name: wpPost.title,
    },
  ];

  return (
    <Layout page>
      <Breadcrumps data={breadcrumps_data} />
      <SubpageHeader title={wpPost.title} center smallMargin />
      <PostInfo data={wpPost} />
      <PostContent data={wpPost} />
      <PostShare data={wpPost} />
    </Layout>
  );
};

export default SinglePost;

export const Head = ({ data: { wpPost } }) => (
  <Seo
    title={wpPost?.seo?.title}
    description={wpPost?.seo?.metaDesc}
    image={wpPost?.featuredImage?.node?.sourceUrl}
  />
);

export const query = graphql`
  query ($id: String!) {
    wpPost(id: { eq: $id }) {
      slug
      content
      excerpt
      uri
      title
      categories {
        nodes {
          name
          slug
        }
      }
      author {
        node {
          avatar {
            url
          }
          username
          firstName
          lastName
          acfAuthor {
            postAuthorName
            postAuthorPosition
            postAuthorLink
            postAuthorDescription
            postAuthorImage {
              sourceUrl
            }
          }
        }
      }
      featuredImage {
        node {
          sourceUrl
        }
      }
      seo {
        metaDesc
        title
      }
      date(locale: "pl", formatString: "DD.MM.YYYY")
      acfPost {
        postUpdateDate
        ad1Header
        ad1Link
        ad1Image {
          sourceUrl
        }
        ad1Text
        ad2Header
        ad2Link
        ad2Image {
          sourceUrl
        }
        ad2Text
      }
    }
  }
`;
